import React, { useState } from 'react';
import { Formik, Form, Field } from 'formik';
import { Row, Col, FormGroup } from 'reactstrap';
import INPUTS_CONST from '../../../constants/inputs';
import { resetPasswordSchema } from '../../../validationRules/login';
import { ErrorHelper, Input } from '../../atoms/input/Input';
import { focusAndScrollToError } from '../../../helpers/formHelper';
import Button from '../../atoms/button/Button';
import ROUTES from '../../../constants/routes';
import Modal, { MODAL_CONTENT } from '../modals/baseModal/Modal';
import GLOBAL_CONST from '../../../constants/global';

export default function ChangePassword({ actions, error, toggleModal, type }) {
  const formName = GLOBAL_CONST.RESETPASSWORD;
  const [showConfirmationModal, setShowConfirmationModal] = useState(false);

  const handleFormSubmit = values => {
    actions.forgotPassword(values);
    setShowConfirmationModal(true);
  };

  const handleCancel = e => {
    e.preventDefault();
    toggleModal();
  };

  return (
    <>
      <Formik
        initialValues={{
          [INPUTS_CONST.email.name]: ''
        }}
        validationSchema={resetPasswordSchema}
        validateOnChange={false}
        onSubmit={handleFormSubmit}
      >
        <Form>
          {error && type === 'forgotpassword' && (
            <ErrorHelper>{error}</ErrorHelper>
          )}
          <FormGroup>
            <Field
              type='email'
              hasIcon
              id={`${formName}-${INPUTS_CONST.email.name}`}
              name={INPUTS_CONST.email.name}
              labelProps={{
                children: INPUTS_CONST.email.label
              }}
              component={Input}
            />
          </FormGroup>
          <Row>
            <Col md={6} className='mb-4'>
              <Button
                onClick={focusAndScrollToError}
                id={`${formName}-submit-btn`}
                type='submit'
                blue
                block
              >
                Submit
              </Button>
            </Col>
            <Col md={6}>
              <Button
                id={`${formName}-cancel-btn`}
                to={ROUTES.login.route}
                redOutline
                block
                onClick={handleCancel}
              >
                Cancel
              </Button>
            </Col>
          </Row>
        </Form>
      </Formik>
      <Modal
        sayTitle={`Forgot Password Submission Confirmation`}
        trigger={false}
        show={showConfirmationModal}
        onClosed={() => {
          toggleModal();
        }}
      >
        {MODAL_CONTENT.forgotPasswordConfirm}
      </Modal>
    </>
  );
}
